import React, { useState } from "react";
import WorldImg from "../../assets/img/World.svg";
import AvailableCountriesModal from "../shared/availableCountries";
import Helpers from "../../helpers/shared.helper";
import Translations from "../../services/translation.service";

const countriesData = Helpers.convertCountriesListBasedOn(true);
export default function AvailableCountries({countries = [], type = ""}) {
    const [openModal, setOpenModal] = useState(false);

    const handleModal = (e) => {
        setOpenModal((prev) => !prev);
    };

    const getFlag = (code) => {
      try {
          return require(`../../assets/img/flagsRounded/country_${countriesData[code]?.iso_2code.toLowerCase()}.webp`);
      } catch {
          return "";
      }
    };

    const slicedCountries = () => {
      const tempCountries = JSON.parse(JSON.stringify(countries));
      return tempCountries?.slice(0, 5) || [];
    }

    return <>
    {type === "summary" ?
      <>
        <div className="summary-available-countries-container">
          <div>
            <div>
              <img src={WorldImg} alt=""/>
              <span>{Translations.keys["stm_countries_in_flexi"]}</span>
            </div>
            <span onClick={handleModal}>
              {Translations.keys["stm_countries_see_all"]}
            </span>
          </div>
          <div>
            {slicedCountries()?.map((item) => {
              return <img src={getFlag(item) || WorldImg} alt={item}/>
            })}
            {countries.length - 5 > 0 &&
              <div>
                +{countries.length - 5}
              </div>
            }
          </div>
        </div>
        <hr />
      </>
    :
      <div className="available-countries-container">
        <div>
          <div>
            <img src={WorldImg} alt=""/>
            <span>{Translations.keys["stm_countries_incl_flexi"]}</span>
          </div>
          <span onClick={handleModal}>
            {Translations.keys["stm_countries_see_all"]}
          </span>
        </div>
        <div>
          {slicedCountries()?.map((item) => {
            return <img src={getFlag(item) || WorldImg} alt={item}/>
          })}
          {countries.length - 5 > 0 &&
          <div>
            +{countries.length - 5}
          </div>
          }
        </div>
      </div>
    }
    {openModal && <AvailableCountriesModal handleModal={handleModal} allCountriesData={countriesData} availableCountries={countries}/>}
  </>
}